(() => {
  if (customElements.get('dut-sale-badge')) return;
  const requests = new Map();
  async function check(path) {
    let url = new URL(path, location.origin);
    if (url.origin !== location.origin) throw new Error('Invalid collection');
    for (;;) {
      url.searchParams.set('section_id', 'dut-sale-status');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Sale status unavailable');
      const status = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-sale]');
      if (!status) throw new Error('Missing sale status');
      if (status.dataset.sale === 'true') return true;
      if (!status.dataset.next) return false;
      url = new URL(status.dataset.next, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid next page');
    }
  }
  customElements.define('dut-sale-badge', class extends HTMLElement {
    connectedCallback() {
      const path = this.dataset.url;
      const cached = requests.get(path);
      if (!cached || Date.now() - cached.time > 60000) {
        requests.set(path, { time: Date.now(), promise: check(path).catch(() => false) });
      }
      requests.get(path).promise.then(sale => { if (this.isConnected) this.hidden = !sale; });
    }
  });
})();
